export enum CountryEnum {
  Germany = 'Germany',
  France = 'France',
  Austria = 'Austria',
}
